import { ArrowRight, Menu, X } from "lucide-react";
import { useState } from "react";
import { ShaklLogo } from "../brand/ShaklLogo";

const navItems = [
  ["Tools", "https://shakl.cc/tools"],
  ["Custom Tools", "https://shakl.cc/custom-tools"],
  ["Free Tools", "https://shakl.cc/#free"],
  ["About", "https://shakl.cc/about"],
  ["Support", "https://shakl.cc/support"],
] as const;

export function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="site-header">
      <a className="brand" href="https://shakl.cc" aria-label="SHAKL home">
        <ShaklLogo />
      </a>
      <nav className="desktop-nav" aria-label="Primary">
        {navItems.map(([label, href]) => (
          <a key={label} href={href}>{label}</a>
        ))}
      </nav>
      <a className="header-cta" href="#workspace">
        Open Alterly <ArrowRight size={16} />
      </a>
      <button
        className="menu-toggle"
        type="button"
        onClick={() => setOpen((value) => !value)}
        aria-label="Toggle menu"
        aria-expanded={open}
      >
        {open ? <X /> : <Menu />}
      </button>
      {open && (
        <nav className="mobile-nav" aria-label="Mobile">
          {navItems.map(([label, href]) => (
            <a key={label} href={href} onClick={() => setOpen(false)}>{label}</a>
          ))}
        </nav>
      )}
    </header>
  );
}
